(ns frontend.ui.component.date-range-picker.style)

(defn input-button
  []
  ^{:pseudo {:hover  {:color "#8ABF4C" :background-color "#fafafa !important"}
             :focus  {:color "#8ABF4C" :background-color "#fafafa !important"}
             :active {:color "#8ABF4C" :background-color "#fafafa !important"}}}
  {:color         "black !important"
   :border-radius "4px"
   :background-color "white !important"
   :transition-duration "100ms"
   :border        "1px solid #999999 !important"})
